module.exports = __webpack_public_path__ + "static/media/booth-foreground.9e527763.svg";